import { PageContainer, PageTitle, useHead, AccountRemovalFulfillForm } from '@mybonus/ui';

import { $FloatBox, Title, FloatWrapper } from './AccountRemovalFulfillView.parts';

export function AccountRemovalFulfillView() {
	useHead({ subtitle: 'Avsluta medlemskap' });

	return (
		<PageContainer>
			<PageTitle>
				<Title>Avsluta medlemskap</Title>
			</PageTitle>

			<FloatWrapper>
				<$FloatBox>
					<AccountRemovalFulfillForm />
				</$FloatBox>
			</FloatWrapper>
		</PageContainer>
	);
}
